import { Suspense, lazy } from "react";
import Nav from "../components/site/Nav";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import StatsBar from "../components/site/StatsBar";
import HowWeWork from "../components/site/HowWeWork";
import LazyMount from "../components/site/LazyMount";
import { useCMS } from "../lib/useCMS";

// Below-the-fold sections: lazy-loaded so they don't block first paint.
const Portfolio    = lazy(() => import("../components/site/Portfolio"));
const About        = lazy(() => import("../components/site/About"));
const CTASection   = lazy(() => import("../components/site/CTASection"));
const Contact      = lazy(() => import("../components/site/Contact"));
const Footer       = lazy(() => import("../components/site/Footer"));

// Decorative site-wide 2D particle layer — fully optional, idle-mounted.
const ParticleField = lazy(() => import("../components/three/ParticleField"));

export default function PublicSite() {
  const data = useCMS();

  return (
    <div className="min-h-screen bg-bg text-primary-fg relative">
      <LazyMount whenIdle rootMargin="0px">
        <Suspense fallback={null}>
          <ParticleField />
        </Suspense>
      </LazyMount>
      <Nav />
      <main className="relative z-[1]">
        <Hero       settings={data.settings} />
        <Services   services={data.services} />
        <StatsBar   stats={data.stats} />
        <HowWeWork />

        <LazyMount rootMargin="400px" minHeight="60vh">
          <Suspense fallback={null}>
            <Portfolio cases={data.cases} />
          </Suspense>
        </LazyMount>

        <LazyMount rootMargin="400px" minHeight="60vh">
          <Suspense fallback={null}>
            <About settings={data.settings} />
          </Suspense>
        </LazyMount>

        <LazyMount rootMargin="400px" minHeight="40vh">
          <Suspense fallback={null}>
            <CTASection settings={data.settings} />
          </Suspense>
        </LazyMount>

        <LazyMount rootMargin="400px" minHeight="50vh">
          <Suspense fallback={null}>
            <Contact settings={data.settings} />
          </Suspense>
        </LazyMount>
      </main>
      <LazyMount rootMargin="400px">
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      </LazyMount>
    </div>
  );
}
